import React from "react";
import { useEffect, useState } from "react";
import { useFormik } from "formik";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "../../../../../../Services/axiosCommon";
import {
  BackButton,
  CancelButton,
  SubmitButton,
} from "../../../../../../Components/Utils/Buttons";
// import Attachement from "./Attachement";
import Dasboard from "../../../../../../Components/Icons/Dasboard";
import * as yup from "yup";
import { Modal, notification } from "antd";
import useFetchMataData from "../../../../../../Components/Hooks/useFetchMataData";
import Breadcrumb from "../../../../../../Components/Utils/Breadcrumb";
import { NuInput, NuLabel, NuSelect, NuTextArea } from "../../../../../../Components/Utils/Input";
import FormikSelectTwo from "../../../../../../Components/Utils/Select";
import axiosInstance from "../../../../../../Services/axiosCommon";
import UseCatSubCatDropDown from "../../../../../../Components/Hooks/useCategoryDropDown";

function EditOthers({open, getData, onCancel,itemsCategory, data,id,projectId ,Category,Division,Unit}) {
  // const {value:Role ,getData:refManPowerRole} = useFetchMataData(`/dropdown/dropdown-details/`,'ManPowerRole')
  // const {value:Category ,getData:refOthersCategory} = useFetchMataData(`/dropdown/dropdown-details/`,'OthersCategory')
  // const {value:Division ,getData:refOtherDivision} = useFetchMataData(`/dropdown/dropdown-details/`,'OtherDivision')
  // const {value:Unit ,getData:refOtherUnit} = useFetchMataData(`/dropdown/dropdown-details/`,'Unit_item')

  // const {value:Unit ,getData:refManPowerUnit} = useFetchMataData(`/dropdown/dropdown-details/`,'ManPowerUnit')
  
    const [api, contextHolder] = notification.useNotification();
  const [isLoading,setIsLoading] = useState(false);
  const [createNew, setCreateNew] = useState({
    projectId: "",
    activity: "",
    category: "",
    division: "",
    amount: "",
    unit: "",
    quantity: "",
    comments: ""
  });
  useEffect(() => {
  
    data&&setCreateNew({
      projectId:data?.projectId||"",
    activity:data?.activity||"",
    category:data?.category||"",
    division:data?.division||"",
    unit:data?.unit||"",
    quantity:data?.quantity||"",
    amount:data?.amount||"",
    comments:data?.comments||""
   
    })
  },[data])
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: createNew,
        validateOnChange: false,
        validateOnBlur: false,
        validationSchema:yup.object({
          activity:yup.string().required("Activity Name is Requried")
        }),
        onSubmit: (value,{resetForm}) => {
          axiosInstance.put(`/others/${projectId}`, value)
          .then((res) => {
              console.log("res",res.data.status);
              if (res.data.status) {
                getData(id);
                resetForm();
                api.success({
                  message: `Manpower Item Update successfully`,
                  description: res?.data?.msg || "Added In The Activity",
                  placement: "bottomRight",
                });
                onCancel();
              } else {
                api.error({
                  message: `Manpower Item Upadate failed`,
                  description: res?.data?.msg || "Network error",
                  placement: "bottomRight",
                });
              }
            })
            .catch((err) => {
              api.error({
                message: `failed`,
                description: err?.data?.msg || "Sever error (or) Network error",
                placement: "bottomRight",
              });
            });
        },
      });
      useEffect(() => {
        const totalPrice = formik?.values?.actual_quantity * formik?.values?.actual_Price
        formik.setFieldValue("amount", totalPrice);
      }, [formik?.values?.actual_quantity,formik?.values?.actual_Price]);
      // const { category: itemsCategory, subCategory: itemsSubCategory } =
      // UseCatSubCatDropDown(
      //   "/category/ItemCategory",
      //   "ItemCategory",
      //   formik?.values?.category
      // );
      return (
        <>
        {contextHolder}
        <Modal
          open={open}
          title={"Edit others"}
          width={"50%"}
          className="my-modal"
          centered
          footer={[]}
          onCancel={onCancel}
        >
        <form onSubmit={formik.handleSubmit} >
          <div className=" w-full flex flex-wrap">
          <NuInput
                           type="text"

                 label="Activity"
                 formik={formik}
                 placeholder="Activity"
                 name="activity"
                 width="w-full md:w-1/2"
                 isRequired={true}
                /> 

                <FormikSelectTwo
                  label="Category"
                  Options={itemsCategory||[]}
                  formik={formik}
                  placeholder="Choose"
                  name="category"
                  width="w-full md:w-1/2"
                  // getFunc={refOthersCategory}
                  displayProperty={"Category"}
                  propertyName={"OthersCategory"}
                  isRequired={true}
                /> 

                <FormikSelectTwo
                  label="Division"
                  Options={Division||[]}
                  formik={formik}
                  placeholder="Choose"
                  name="division"
                  width="w-full md:w-1/2"
                  // getFunc={refOtherDivision}
                  displayProperty={"Division"}
                  propertyName={"OtherDivision"}
                  isRequired={true}
                /> 

              

                <FormikSelectTwo
                  label="Unit"
                  Options={Unit||[]}
                  formik={formik}
                  placeholder="Choose"
                  name="unit"
                  width="w-full md:w-1/2"
                  // getFunc={refOtherUnit}
                  displayProperty={"Unit"}
                  propertyName={"OtherUnit"}
                  isRequired={true}
                />
 
                <NuInput
                             type="number"

                 label="Quantity"
                 formik={formik}
                 placeholder="Quantity"
                 name="quantity"
                 width="w-full md:w-1/2"
                 isRequired={true}
                />  
                  <NuInput
                 type="number"
                 label="Amount"
                 formik={formik}
                 placeholder="Amount"
                 name="amount"
                 width="w-full md:w-1/2"
                 isRequired={true}
                />    

                <NuTextArea
                  label="Comments"
                  placeholder="Comments"
                  formik={formik}
                  name="comments"
                  // width="w-full md:w-2/3"
                  new_width="w-full"
                />

       <div className="w-full flex justify-end item-end float-right mx-auto md:mx-0 gap-2 mt-2 md:mr-4">
                  <CancelButton handleClick={onCancel} />
                  <SubmitButton isLoading={isLoading} />
                </div>
          </div>
          </form>
        </Modal>
        </>
      )
}

export default EditOthers;